import { Navigate } from "react-router-dom"
import FullscreenLoading from "../pages/Prescription/Components/FullScreenLoader"
import { useAuthStore } from "../stores/authStores"

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const token = useAuthStore((s) => s.token)
    const isAuthLoading = useAuthStore((s) => s.isAuthLoading)

    if (isAuthLoading) return <FullscreenLoading />

    return token ? children : <Navigate to="/login" replace />
}